import { render, staticRenderFns } from "./OrganismTutorial.vue?vue&type=template&id=671c9cea&scoped=true&"
import script from "./OrganismTutorial.vue?vue&type=script&lang=js&"
export * from "./OrganismTutorial.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTutorial.vue?vue&type=style&index=0&id=671c9cea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c9cea",
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismTutorial.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Funiverse%2FOrganismTutorial.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,OrganismsOrganismInfoPopup: require('/app/components/organisms/OrganismInfoPopup.vue').default})
